import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import DrawerDesktop from "../components/Drawer/Desktop/DrawerDesktop.component";
import { menuOptions } from "../components/Drawer/data/Drawer.data";
import Footer from "../components/Footer/Footer.component";
import Navbar from "../components/Navbar/Navbar.component";
import classes from "./DefaultLayout.module.scss";

const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  //iletişim de footer gözükmesin
  const location = useLocation();
  const isContactPage = location.pathname === "/iletisim";

  return (
    <>
      <Navbar onMenuClick={() => setDrawerOpen(!drawerOpen)} />
      <main id="main-content">{children}</main>
      {!isContactPage && <Footer />}
      {drawerOpen && (
        <div className={classes.drawerWrapper}>
          <DrawerDesktop
            closeDrawer={() => setDrawerOpen(false)}
            menuOptions={menuOptions}
          />
          <div
            className={classes.backdrop}
            onClick={() => setDrawerOpen(false)}
          ></div>
        </div>
      )}
    </>
  );
};

export default DefaultLayout;
